import React from 'react'
import PropTypes from 'prop-types'
import {HiOutlineCheckCircle, HiOutlineBan} from 'react-icons/hi'
import { Badge } from 'components/ui';

const SemaphoreText = (props) => {
    const {
        t, 
        statusId,
        textToGreen,
        textToYellow,
        textToRed,
        className
    } = props;

    var statusText;
    var statusClassName = className

    switch (statusId) {
        case 0:
            statusText = textToRed;
            statusClassName += ' bg-red-500';
            break;
        case 1:
            statusText = textToGreen;
            statusClassName += ' bg-emerald-500';
            break;
        case 2:
            statusText = textToYellow;
            statusClassName += ' bg-yellow-500';
            break;
        default:
            statusText = "";
    }

    return (
        <Badge innerClass={statusClassName} content={statusText}></Badge>
    )
   
}

SemaphoreText.propTypes = {
    statusId: PropTypes.number,
    textToGreen: PropTypes.string,
    textToYellow: PropTypes.string,
    textToRed: PropTypes.string,
    className: PropTypes.string
}

SemaphoreText.defaultProps = {
    statusId: 1,
    textToGreen: "",
    textToYellow: "",
    textToRed: "",
    className: ""
}

export default SemaphoreText
